<template>
  <div v-if="transfers.length" class="mt-3">
    <template v-if="readonly">
      <button
        type="button"
        class="btn btn-link p-0 text-muted small text-decoration-none"
        :aria-expanded="expanded"
        @click="expanded = !expanded"
      >
        <i :class="expanded ? 'fal fa-chevron-down' : 'fal fa-chevron-right'" />
        {{ trans("admin.cdr.integrationAck.title") }}
      </button>
      <div v-if="expanded" class="card mt-2">
        <div class="card-body">
          <AckList :state="state" readonly />
        </div>
      </div>
    </template>
    <div v-else class="card">
      <div class="card-body">
        <h6 class="card-title">
          {{ trans("admin.cdr.integrationAck.title") }}
        </h6>
        <p class="text-muted small">
          {{ trans("admin.cdr.integrationAck.description") }}
        </p>
        <AckList :state="state" @change="emitState" />
      </div>
    </div>
  </div>
</template>

<script>
import AckList from "./CdrIntegrationAcknowledgementsList.vue";

export default {
  components: { AckList },
  props: {
    transfers: { type: Array, required: true },
    readonly: { type: Boolean, default: false },
  },
  emits: ["change"],
  data() {
    return {
      state: this.buildState(),
      expanded: false,
    };
  },
  watch: {
    transfers: {
      handler() {
        this.state = this.buildState();
        this.emitState();
      },
      deep: true,
    },
  },
  mounted() {
    this.emitState();
  },
  methods: {
    buildState() {
      return this.transfers.map((t) => ({
        transfer_type: t.transfer_type,
        label: t.label,
        status: t.status ?? null,
        motivation: t.motivation ?? null,
      }));
    },
    emitState() {
      this.$emit(
        "change",
        this.state.map((s) => ({
          transfer_type: s.transfer_type,
          status: s.status,
          motivation: s.motivation,
        })),
      );
    },
  },
};
</script>
